module.exports = __webpack_public_path__ + "static/media/linhas-onibus-header.279448ae.png";